<template>
  <div class="mt-4">
    <form
      @submit.prevent="submit"
      @keydown="form.onKeydown($event)"
      enctype="multipart/form-data"
    >
      <alert-error
        v-if="form.errors.get('message')"
        :form="form"
        :message="form.errors.get('message')"
      ></alert-error>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-3">
              <div class="card mb-n1">
                <div class="card-body mb-n2">
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="d-flex flex-column align-items-center text-center"
                      >
                        <img
                          v-if="urlImage"
                          class="rounded-circle"
                          alt="Profil"
                          width="200"
                          height="200"
                          :src="urlImage"
                          data-holder-rendered="true"
                        />
                        <img
                          v-else
                          class="rounded-circle"
                          alt="Profil"
                          width="200"
                          height="200"
                          :src="URL_LOCAL_FILE + '/images/no-avatar.png'"
                          data-holder-rendered="true"
                        />
                        <div class="mt-3">
                          <p class="text-secondary mb-1">
                            {{
                              user.prenom
                                ? user.nom + ' ' + user.prenom
                                : user.nom
                            }}
                          </p>
                          <p class="text-muted font-size-sm">
                            {{ user.email }}
                          </p>
                          <div>
                            <input
                              ref="imgProfileUpload"
                              type="file"
                              style="display: none"
                              accept="image/*"
                              :class="{
                                'is-invalid': form.errors.has('image'),
                              }"
                              @change="onChangeImgProfiler"
                            />
                            <has-error
                              :form="form"
                              field="image"
                              class="mb-4"
                            ></has-error>
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex"
                        :class="
                          urlImage !== null
                            ? 'justify-content-between'
                            : 'justify-content-center'
                        "
                      >
                        <b-button
                          size="sm"
                          variant="outline-custom-primary"
                          @click="chooseImgProfile"
                          ><i class="fas fa-image" aria-hidden="true"></i>
                          Changer
                        </b-button>
                        <b-button
                          v-if="urlImage"
                          size="sm"
                          variant="outline-danger"
                          @click="onClearImgProfile"
                          ><i class="fas fa-trash" aria-hidden="true"></i>
                          Supprimer</b-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-12 py-0">
                  <div class="list-group">
                    <span class="list-group-item">
                      <span>
                        <i class="fas fa-calendar" aria-hidden="true"></i>
                        Incrit depuis
                      </span>
                      <b-badge variant="primary" class="float-right">
                        {{ form.created_at | formatDate('DD/MM/YYYY') }}
                      </b-badge>
                    </span>
                    <span class="list-group-item">
                      <span>
                        <i
                          class="fas fa-lock text-warning"
                          aria-hidden="true"
                        ></i>
                        Droit
                      </span>
                      <b-badge variant="primary" class="float-right">
                        {{ form.droit }}
                      </b-badge>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-9">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="nom"
                          >Nom <span class="text-danger">*</span></label
                        >
                        <input
                          class="form-control"
                          :class="{ 'is-invalid': form.errors.has('nom') }"
                          id="nom"
                          v-model="form.nom"
                          type="text"
                          placeholder="Nom"
                          maxlength="50"
                          required
                        />
                        <has-error :form="form" field="nom"></has-error>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="prenom">Prénom </label>
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('prenom'),
                          }"
                          id="prenom"
                          v-model="form.prenom"
                          type="text"
                          placeholder="Prénom"
                          maxlength="50"
                        />
                        <has-error :form="form" field="prenom"></has-error>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="centre_cout">Centre de coût </label>
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('centre_cout'),
                          }"
                          id="centre_cout"
                          v-model="form.centre_cout"
                          type="text"
                          placeholder="Centre de coût"
                          disabled
                        />
                        <has-error :form="form" field="centre_cout"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-n4">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="langue"
                          >Langue <span class="text-danger">*</span></label
                        >
                        <v-custom-select
                          label="nom"
                          id="langue"
                          :options="langues"
                          :reduce="(langue) => langue.uuid"
                          v-model="form.langue"
                          placeholder="Langue"
                        >
                          <template v-slot:option="{ nom }">
                            <h5 style="margin: 0">{{ nom }}</h5>
                          </template>
                          <template #no-options> Aucune données </template>
                          <template #search="{ attributes, events }">
                            <input
                              id="langue"
                              class="custom-select-height vs__search"
                              v-bind="attributes"
                              v-on="events"
                            />
                          </template>
                        </v-custom-select>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('langue'),
                          }"
                        />
                        <has-error :form="form" field="langue"></has-error>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="civilite"
                          >Civilité <span class="text-danger">*</span></label
                        >
                        <v-custom-select
                          label="nom"
                          id="civilite"
                          :options="civilites"
                          :reduce="(civilite) => civilite.uuid"
                          v-model="form.civilite"
                          placeholder="Civilité"
                        >
                          <template v-slot:option="{ nom }">
                            <h5 style="margin: 0">{{ nom }}</h5>
                          </template>
                          <template #no-options> Aucune données </template>
                          <template #search="{ attributes, events }">
                            <input
                              id="civilite"
                              class="custom-select-height vs__search"
                              v-bind="attributes"
                              v-on="events"
                            />
                          </template>
                        </v-custom-select>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('civilite'),
                          }"
                        />
                        <has-error :form="form" field="civilite"></has-error>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="genre"
                          >Genres <span class="text-danger">*</span></label
                        >
                        <v-custom-select
                          label="nom"
                          id="civilite"
                          :options="genres"
                          v-model="form.genre"
                          :reduce="(genre) => genre.uuid"
                          placeholder="Genre"
                        >
                          <template v-slot:option="{ nom }">
                            <h5 style="margin: 0">{{ nom }}</h5>
                          </template>
                          <template #no-options> Aucune données </template>
                          <template #search="{ attributes, events }">
                            <input
                              id="genre"
                              class="custom-select-height vs__search"
                              v-bind="attributes"
                              v-on="events"
                            />
                          </template>
                        </v-custom-select>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('genre'),
                          }"
                        />
                        <has-error :form="form" field="genre"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-n4">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="pays">Pays </label>
                        <input
                          class="form-control"
                          :class="{ 'is-invalid': form.errors.has('pays') }"
                          id="pays"
                          v-model="form.pays"
                          type="text"
                          placeholder="Pays"
                          maxlength="50"
                        />
                        <has-error :form="form" field="pays"></has-error>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="ville">Ville </label>
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('ville'),
                          }"
                          id="ville"
                          v-model="form.ville"
                          type="text"
                          placeholder="Ville"
                          maxlength="20"
                        />
                        <has-error :form="form" field="ville"></has-error>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="departement">Département </label>
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('departement'),
                          }"
                          id="departement"
                          v-model="form.departement"
                          type="text"
                          placeholder="Département"
                          maxlength="50"
                        />
                        <has-error :form="form" field="departement"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-n4">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="email"
                          >Email <span class="text-danger">*</span></label
                        >
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('email'),
                          }"
                          id="email"
                          v-model="form.email"
                          type="email"
                          placeholder="Email"
                          maxlength="100"
                          required
                        />
                        <has-error :form="form" field="email"></has-error>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="telephone">Téléphone </label>
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('telephone'),
                          }"
                          id="telephone"
                          v-model="form.telephone"
                          type="text"
                          placeholder="Téléphone"
                          maxlength="20"
                        />
                        <has-error :form="form" field="telephone"></has-error>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="code_postal">Code postal </label>
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('code_postal'),
                          }"
                          id="code_postal"
                          v-model="form.code_postal"
                          type="text"
                          placeholder="Code postal"
                          maxlength="20"
                        />
                        <has-error :form="form" field="code_postal"></has-error>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-n4">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="fax">Fax </label>
                        <input
                          class="form-control"
                          :class="{ 'is-invalid': form.errors.has('fax') }"
                          id="fax"
                          v-model="form.fax"
                          type="text"
                          placeholder="Fax"
                          maxlength="20"
                        />
                        <has-error :form="form" field="fax"></has-error>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="date_naissance">Date de naissance </label>
                        <date-picker
                          v-model="form.date_naissance"
                          name="date_naissance"
                          placeholder="Date de naissance"
                          lang="fr"
                          format="DD/MM/YYYY"
                          value-type="DD/MM/YYYY"
                        ></date-picker>
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('date_naissance'),
                          }"
                          type="hidden"
                        />
                        <has-error
                          :form="form"
                          field="date_naissance"
                        ></has-error>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="nationalite">Nationalité </label>
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('nationalite'),
                          }"
                          id="nationalite"
                          v-model="form.nationalite"
                          type="text"
                          placeholder="Nationalité"
                          maxlength="50"
                        />
                        <has-error :form="form" field="nationalite"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-n4">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="adresse">Adresse </label>
                        <input
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('adresse'),
                          }"
                          id="adresse"
                          v-model="form.adresse"
                          type="text"
                          placeholder="Adresse"
                          maxlength="50"
                        />
                        <has-error :form="form" field="adresse"></has-error>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="password">Mot de passe</label>
                        <div class="input-group">
                          <input
                            id="password"
                            v-model="form.password"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('password'),
                            }"
                            :type="showPassword ? 'text' : 'password'"
                            placeholder="Mot de passe"
                          />
                          <div class="input-group-append">
                            <span
                              class="input-group-text btn"
                              @click="showPassword = !showPassword"
                            >
                              <i
                                :class="
                                  showPassword
                                    ? 'fas fa-eye'
                                    : 'fas fa-eye-slash'
                                "
                                aria-hidden="true"
                              ></i>
                            </span>
                          </div>
                          <has-error :form="form" field="password"></has-error>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="password-confirmation"
                          >Confirmation du mot de passe</label
                        >
                        <div class="input-group">
                          <input
                            id="password-confirmation"
                            v-model="form.password_confirmation"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has(
                                'password_confirmation'
                              ),
                            }"
                            :type="showPasswordConfirm ? 'text' : 'password'"
                            placeholder="Mot de passe"
                            autocomplete="new-password"
                          />
                          <div class="input-group-append">
                            <span
                              class="input-group-text btn"
                              @click="
                                showPasswordConfirm = !showPasswordConfirm
                              "
                            >
                              <i
                                :class="
                                  showPasswordConfirm
                                    ? 'fas fa-eye'
                                    : 'fas fa-eye-slash'
                                "
                                aria-hidden="true"
                              ></i>
                            </span>
                          </div>
                          <has-error
                            :form="form"
                            field="password_confirmation"
                          ></has-error>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-12 text-right">
          <ButtonLoader
            :busy="form.busy"
            type="submit"
            customClass="btn btn-custom-primary w-40"
            loadText="Traitement en cours..."
            Text="Enregistrer"
            style="min-width: 100px"
          ></ButtonLoader>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import URL from '@/http/auth.url';
import config from '@/config';
import { objectToFormData } from 'object-to-formdata';
import Form from 'vform';

export default {
  data() {
    return {
      form: new Form({
        nom: '',
        prenom: '',
        telephone: '',
        fax: '',
        email: '',
        image: null,
        clear_image: '',
        date_naissance: '',
        nationalite: '',
        password: '',
        adresse: '',
        code_postal: '',
        ville: '',
        pays: '',
        departement: '',
        genre: '',
        civilite: '',
        centre_cout: '',
        langue: '',
        role: null,
      }),
      urlImage: null,
      langues: [],
      genres: [],
      civilites: [],
      showPassword: false,
      showPasswordConfirm: false,
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
      title: 'Profil',
    };
  },
  components: {
    DatePicker,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    chooseImgProfile() {
      this.$refs.imgProfileUpload.click();
    },
    onChangeImgProfiler(e) {
      const file = e.target.files[0];
      this.form.image = file;
      this.urlImage = global.URL.createObjectURL(file);
      this.form.clear_image = false;
    },
    onClearImgProfile() {
      this.form.image = null;
      this.urlImage = null;
      this.form.clear_image = true;
    },

    init() {
      this.urlImage = null;
      this.langues = [];
      this.genres = [];
      this.civilites = [];
      this.showPassword = false;
      this.showPasswordConfirm = false;

      window.axios
        .all([
          window.axios.get(URL.PROFILE_REQUIREMENTS),
          window.axios.get(URL.MY_PROFILE),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.langues = resp1.data.langues;
            this.genres = resp1.data.genres;
            this.civilites = resp1.data.civilites;

            Object.assign(this.form, resp2.data.user);
            this.urlImage = this.form.url_image;
          })
        )
        .catch();
    },
    submit() {
      this.form._method = 'PUT';
      this.form
        .post(URL.MY_PROFILE, {
          transformRequest: [
            function (data) {
              return objectToFormData(data);
            },
          ],
        })
        .then((resp) => {
          this.$store.dispatch('auth/checkUser');

          this.showSimpleAlerte('top-end', 'success', resp.data.message);

          this.form.reset();
          this.init();
        })
        .catch((err) => {
          if (
            err.response.data.message !== undefined &&
            err.response.data.message !== ''
          )
            this.showSimpleAlerte(
              'top-end',
              'error',
              err.response.data.message
            );
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
